import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';
import { discoverGalleryPhotos, mergeGalleryPhotos } from '../utils/photoDiscovery';

const Genes = () => {
  const galleryRef = useRef();
  const [showMore, setShowMore] = useState(false);
  const navigate = useNavigate();
  const [photos, setPhotos] = useState(galleryData.genes || []);

  // Discover additional photos from S3
  useEffect(() => {
    const loadDiscoveredPhotos = async () => {
      try {
        const discoveredPhotos = await discoverGalleryPhotos('genes');
        const mergedPhotos = mergeGalleryPhotos(galleryData.genes || [], discoveredPhotos);
        setPhotos(mergedPhotos);
      } catch (error) {
        console.warn('Could not load discovered photos:', error);
        setPhotos(galleryData.genes || []);
      }
    };

    loadDiscoveredPhotos();
  }, []);

  const handleViewRestaurant = () => {
    galleryRef.current?.openGallery(0);
  };

  const handleRecipes = () => {
    // Navigate to Recipes page
    navigate('/recipes');
  };

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <section id="genes" className="section genes-section">
      <div className="section-header">
        <img src="/images/genes.svg" alt="Gene's" className="section-icon" />
        <h1>Gene's Corner House Restaurant & Banquet</h1>
      </div>
      <p>A brief history of a Gene's, a restaurant that meant so much to the owners, staff, & loyal customers.</p>

         {showMore && (
          <div className="extended-intro">
            <p>For over 60 years Gene's was a family owned and operated restaurant. Gene & Jean founded the orginal restaurant on Queen Street in the 1950s.  I don't know when but they eventually relocated to 1219 South Main Street, Plantsville, CT 06479.</p>
			<p>Purchased by Pasquale, Giuseppina, Connie, & Ralph in the late 1980s. The staff, mostly family & friends, worked together making memories with their customers for over 20 great years.</p>
			<p>If you visit today you'll find that you can still grab some food, not from Gene's but from the current owner's of the property <a href="https://slidersgrillbar.com/southington-plantsville/" target="_blank" rel="noreferrer"><font color="#C0C0FF">Slider's Grill & Bar</font></a></p>
          </div>
        )}

      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleCelebration}>
          <i className="fas fa-circle-info"></i>
          {showMore ? 'Less' : 'About Gene\'s'}
        </button>

        <button className="cta-btn secondary" onClick={handleRecipes}>
          <i className="fas fa-utensils"></i>
          Our Recipes
        </button>

		<button className="cta-btn secondary" onClick={handleViewRestaurant}>
          <i className="fas fa-store"></i>
          Revisit Gene's
        </button>
      </div>
      
      <Gallery 
        ref={galleryRef} 
        images={photos} 
        sectionName=" "
      />
    </section>
  );
};

export default Genes;
